module.exports = __webpack_public_path__ + "img/bg-breadcrumbs.7b9b4eb7.jpg";